import React, { useState } from 'react'
import styled, { css } from 'styled-components'

import { Heading2 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Options = styled.button`
  display: flex;
  justify-content: center;
  padding: 7px;
  border: 2px solid #efedf8;
  border-radius: 8px;
  :not(:last-child) {
    margin-bottom: 48px;
  }
`

const Option = styled.div`
  width: 244px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 20px;
  line-height: 34px;
  letter-spacing: 0.5px;
  :nth-child(2) {
    margin-left: 12px;
  }
  :after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    border-radius: 8px;
    z-index: -1;
  }
  :first-child:after {
    transform: translateX(25px);
  }
  :nth-child(2):after {
    transform: translateX(-25px);
  }
  ${(p) =>
    p.active &&
    css`
      :after {
        transition: transform 0.2s ease-out;
        background-color: #e6e2fc;
      }
      :first-child:after {
        transform: translateX(0px);
      }
      :nth-child(2):after {
        transform: translateX(0px);
      }
    `}
`

const Toggle = () => {
  const [selectedOption, setSelectedOption] = useState(0)
  const toggleOption = () => {
    if (selectedOption === 0) {
      setSelectedOption(1)
    } else {
      setSelectedOption(0)
    }
  }
  const [selectedOption2, setSelectedOption2] = useState(1)
  const toggleOption2 = () => {
    if (selectedOption2 === 0) {
      setSelectedOption2(1)
    } else {
      setSelectedOption2(0)
    }
  }
  return (
    <>
      <Heading>Toggle</Heading>
      <Options onClick={toggleOption}>
        <Option active={selectedOption === 0}>Heading 1</Option>
        <Option active={selectedOption === 1}>Heading 2</Option>
      </Options>
      <Options onClick={toggleOption2}>
        <Option active={selectedOption2 === 0}>Heading 1</Option>
        <Option active={selectedOption2 === 1}>Heading 2</Option>
      </Options>
    </>
  )
}

export default Toggle
